export default "__VITE_ASSET__m9AJs9qz__"